import { TableCell, TableRow } from "@mui/material";

export const TableHeaderRow = () => {
    return (
        <TableRow>
            <TableCell >Emoji</TableCell>
            <TableCell>Task</TableCell>
            <TableCell>Type</TableCell>
            <TableCell>Completion Criteria</TableCell>
            <TableCell>Created By</TableCell>
            <TableCell>Assigned Athletes</TableCell>
            <TableCell padding="checkbox">Actions</TableCell>
        </TableRow>
    );
};
